interface MinerBadgeProps {
  name: string;
  mempoolId?: string | null;
  nameColor: string;
  minedOn?: string;
}

export const MinerBadge = ({
  name,
  mempoolId,
  nameColor,
  minedOn,
}: MinerBadgeProps) => {
  const card = (
    <>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <div style={{ fontSize: '2em', lineHeight: 1 }}>⛏️</div>
        <div>
          <div
            style={{
              fontSize: '1.2em',
              fontWeight: 'bold',
              color: nameColor,
            }}
          >
            {name}
          </div>
          <div
            style={{
              fontSize: '0.9em',
              color: '#8b92a8',
              marginTop: '2px',
            }}
          >
            Bitcoin Mining Pool
          </div>
        </div>
      </div>
      {minedOn && (
        <div
          style={{
            fontSize: '0.85em',
            color: '#8b92a8',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
          }}
        >
          <span style={{ color: '#8b92a8', whiteSpace: 'nowrap' }}>
            Mined on:
          </span>
          <span>{minedOn}</span>
        </div>
      )}
    </>
  );

  if (mempoolId) {
    return (
      <a
        href={`https://mempool.space/mining/pool/${mempoolId}`}
        target="_blank"
        rel="noopener"
        style={{ textDecoration: 'none', display: 'block' }}
      >
        {card}
      </a>
    );
  }

  return card;
};

